import React from 'react';
import MedicalHistoryConfigForm, {
	MedicalHistoryConfigFormValues,
} from './MedicalHistoryConfigForm';
import useLoading from '../../../../../Base/Hooks/useLoading';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import {
	MedicalHistoryType,
	useUpdateMedicalHistoryTypeMutation,
} from '../../../../../../graphql/graphql';

interface Props {
	item: MedicalHistoryType;
	onUpdate: () => void;
}

const MedicalHistoryConfigUpdate: React.FC<Props> = ({ item, onUpdate }) => {
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { displayError } = useApiClient();
	const [updateMedicalHistoryType] = useUpdateMedicalHistoryTypeMutation();

	const handleSubmit = async (values: MedicalHistoryConfigFormValues) => {
		setIsLoading(true);
		try {
			const response = await updateMedicalHistoryType({
				where: { id: item.id },
				input: { name: values.name },
			}).unwrap();

			if (response.updateMedicalHistoryType) {
				onUpdate();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<MedicalHistoryConfigForm
			onSubmit={handleSubmit}
			submitText='base.shared.edit'
			defaultValues={{
				name: item.name,
			}}
		/>
	);
};

export default MedicalHistoryConfigUpdate;
